
import PropTypes from 'prop-types'
import './champs-obligatoires.scss'


export const ChampsObligatoires = (props) => {
    const { children = "Champs Obligatoires", className = '' } = props

    return <p className={`champ mb-0 mt-4${className}`}><small className={'text-danger'}>*</small> {children}</p>
};